import { useSyncExternalStore } from 'react';
import { useParams } from 'react-router-dom';
import { userPrefLocalResource } from 'app/core/utils/localUserPrefs.js';
const getProjectPinnedOptions = () => {
    var _a;
    const { projectId } = useParams();
    const lsPinnedOptions = (_a = userPrefLocalResource.getData(`tables.pinned.${projectId}`)) !== null && _a !== void 0 ? _a : [];
    return JSON.stringify(lsPinnedOptions);
};
const subscribe = (callback) => {
    window.addEventListener('storage', callback);
    return () => {
        window.removeEventListener('storage', callback);
    };
};
const usePinnedOptions = () => {
    const { projectId } = useParams();
    const lsPinnedOptions = useSyncExternalStore(subscribe, getProjectPinnedOptions);
    const pinnedOptions = JSON.parse(lsPinnedOptions);
    const setPinnedOptions = (newOptions) => {
        userPrefLocalResource.setData(`tables.pinned.${projectId}`, newOptions);
        window.dispatchEvent(new Event('storage'));
    };
    return [pinnedOptions, setPinnedOptions];
};
export default usePinnedOptions;
